import { render, staticRenderFns } from "./AMSDiscount.vue?vue&type=template&id=9c97c142&scoped=true&"
import script from "./AMSDiscount.vue?vue&type=script&lang=ts&"
export * from "./AMSDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./AMSDiscount.vue?vue&type=style&index=0&id=9c97c142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c97c142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
